/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendTestEmailRequest
 */
export interface SendTestEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendTestEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the SendTestEmailRequest interface.
 */
export function instanceOfSendTestEmailRequest(value: object): value is SendTestEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SendTestEmailRequestFromJSON(json: any): SendTestEmailRequest {
    return SendTestEmailRequestFromJSONTyped(json, false);
}

export function SendTestEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendTestEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function SendTestEmailRequestToJSON(json: any): SendTestEmailRequest {
    return SendTestEmailRequestToJSONTyped(json, false);
}

export function SendTestEmailRequestToJSONTyped(value?: SendTestEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

